module.exports = __webpack_public_path__ + "img/equityIcon4.a281b4ad.png";